import React, { useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Box, ButtonStyled, MainHeading, Span } from "../../styled/Elements";
import { FaqsWrapper } from "./Styled";
import { ChevronDown, ChevronUp } from "../../styled/AllImages";

const Faqs = ({ data }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [activeItem, setActiveItem] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const toggleItem = (index) => {
    setActiveItem(activeItem === index ? null : index);
  };

  const visibleData = showAll ? data : data.slice(0, 6);

  return (
    <FaqsWrapper
      className="container-fluid common-space faqsFluid py-5"
      lang={language}
      id="faqs"
    >
      <Container>
        <Row className="faqsRow">
          <Col md={12}>
            <Box className="mb-3">
              <MainHeading
                lang={language}
                className="main-heading justify-content-center text-center lh-1"
                color="var(--themeColor)"
                size="2.4rem"
                lh="60px"
                weight="950"
                style={{ lineHeight: "60px" }}
              >
                {t("everything_you_need_to_know_about_falhub")}
              </MainHeading>
            </Box>
          </Col>

          <Col lg={12} className="sliderWrapper">
            {visibleData.map((list, index) => (
              <Box
                key={index}
                className={`item-container ${
                  activeItem === index ? "active-item-box" : ""
                }`}
                onClick={() => toggleItem(index)}
              >
                <Box
                  className="item-box"
                  style={{
                    borderBottom:
                      activeItem === index ? "1px solid var(--border)" : "",
                  }}
                >
                  <Span className="d-flex gap-2 align-items-center item-box-heading">
                    {t(list.question)}
                  </Span>
                  {activeItem === index ? <ChevronUp /> : <ChevronDown />}
                </Box>
                {activeItem === index && (
                  <Box className="item-box-text">{list.render(t, language)}</Box>
                )}
              </Box>
            ))}

            {data.length > 6 && (
              <Box className="text-center d-flex justify-content-center mt-4">
                
                <ButtonStyled
                  label={showAll ? t("show_less") : t("show_more")}
                  color="var(--white)"
                  bg="var(--themeColorSecondary)"
                  // clName={"signup-btn"}
                  onClick={() => setShowAll(!showAll)}
                />
              </Box>
            )}
          </Col>
        </Row>
      </Container>
    </FaqsWrapper>
  );
};

export default Faqs;
